import {AgentLicense} from "./AgentLicense";
import {AgentOfficePhone} from "./Agent";
import {MediaWithType} from "./MediaWithType";

export enum AgentSignatureType {
  AGENT = "AGENT",
  AGENCY = "AGENCY"
}

export enum AgentSignatureFormat {
  DIGITAL = "DIGITAL",
  PRINT = "PRINT"
}

export enum AgentSignatureElement {
  BRAND_NAME = "BRAND_NAME",
  ADDRESS = "ADDRESS",
  EMAIL_ID = "EMAIL_ID",
  PHONE = "PHONE",
  OFFICE_PHONE = "OFFICE_PHONE",
  WEBSITE = "WEBSITE",
  USER_FULL_NAME = "USER_FULL_NAME",
  USER_EMAIL = "USER_EMAIL",
  USER_PHONE = "USER_PHONE",
  USER_OFFICE_PHONE = "USER_OFFICE_PHONE",
  USER_LICENSE = "USER_LICENSE",
  USER_SIGNATURE_FIELD = "USER_SIGNATURE_FIELD",
  CUSTOM_TEXT = "CUSTOM_TEXT",
  CUSTOM_EMAIL = "CUSTOM_EMAIL",
  CUSTOM_PHONE = "CUSTOM_PHONE",
  CUSTOM_TITLE = "CUSTOM_TITLE"
}
export const AgentSignatureElementLabel: Partial<Record<AgentSignatureElement, string>> = {
  [AgentSignatureElement.BRAND_NAME]: "Brand Name",
  [AgentSignatureElement.ADDRESS]: "Address",
  [AgentSignatureElement.EMAIL_ID]: "Email",
  [AgentSignatureElement.PHONE]: "Mobile Phone",
  [AgentSignatureElement.OFFICE_PHONE]: "Office Phone",
  [AgentSignatureElement.WEBSITE]: "Website URL"
};
export type AgentSignatureElementToDataMapTypeInstance = {
  [AgentSignatureElement.BRAND_NAME]: string;
  [AgentSignatureElement.ADDRESS]: string;
  [AgentSignatureElement.EMAIL_ID]: string;
  [AgentSignatureElement.PHONE]: string;
  [AgentSignatureElement.OFFICE_PHONE]: AgentOfficePhone;
  [AgentSignatureElement.WEBSITE]: string;
  [AgentSignatureElement.USER_FULL_NAME]: string;
  [AgentSignatureElement.USER_EMAIL]: string;
  [AgentSignatureElement.USER_SIGNATURE_FIELD]: string;
  [AgentSignatureElement.USER_PHONE]: string;
  [AgentSignatureElement.USER_OFFICE_PHONE]: AgentOfficePhone;
  [AgentSignatureElement.USER_LICENSE]: AgentLicense;
  [AgentSignatureElement.CUSTOM_TEXT]: string;
  [AgentSignatureElement.CUSTOM_EMAIL]: string;
  [AgentSignatureElement.CUSTOM_PHONE]: string;
  [AgentSignatureElement.CUSTOM_TITLE]: string;
};
export type AvailableSignatureElementTypes = keyof AgentSignatureElementToDataMapTypeInstance;

export type SignatureElementDataType<SignatureElementType extends AvailableSignatureElementTypes> =
  AgentSignatureElementToDataMapTypeInstance[SignatureElementType];
export interface AgentSignatureElementSettings<SignatureElementType extends AvailableSignatureElementTypes> {
  type: SignatureElementType;
  value: SignatureElementDataType<SignatureElementType>;
}

export interface AgentSignature {
  type: AgentSignatureType;
  format: AgentSignatureFormat;
  photo?: MediaWithType;
  signatureElementsSettings: AgentSignatureElementSettings<AvailableSignatureElementTypes>[];
}
